import { AnyAction, isRejected } from '@reduxjs/toolkit';
import { UnknownAsyncThunkRejectedAction } from '@reduxjs/toolkit/dist/matchers';

import { isAxiosAuthError } from './isAxiosAuthError';

export const isAuthRejectedAction = (
  action: AnyAction,
): action is UnknownAsyncThunkRejectedAction => {
  return isRejected(action) && isAxiosAuthError(action?.payload);
};
